export default __webpack_public_path__ + "static/media/mute.a5b63b1b.svg";